module.exports = __webpack_public_path__ + "media/referral/link_icon-b07b7e74.svg";